async function executeUntilComplete(options) {
    const { maxRetry, delayInMS, operation, completeChecker } = options;
    let retryCount = 0;
    let lastResult;
    let lastError = new Error('failed to do executeUntilComplete');
    while(retryCount <= maxRetry){
        retryCount++;
        try {
            lastResult = await operation();
            if (completeChecker(lastResult)) {
                return lastResult;
            }
        } catch (error) {
            lastError = error;
            if (retryCount >= maxRetry) {
                throw error;
            }
        }
        await wait(delayInMS);
    }
    if (lastResult) {
        return lastResult;
    }
    throw lastError;
}
function wait(timeInMS) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(undefined);
        }, timeInMS);
    });
}

export { executeUntilComplete as default };
//# sourceMappingURL=executeUntil.util.js.map
